<template>
    <div class="content-wrapper">
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.import.record')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">
                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <!-- Filters -->
                <div class="card">
                    <div class="card-header bg-light">
                        <h3 class="card-title">{{$t('filters')}}</h3>
                        <div class="text-right">
                            <b-button variant="primary" size="sm" @click="detailedSearch = !detailedSearch">
                                {{$t('button.detailedSearch')}}</b-button>
                            <b-button variant="default" size="sm" @click="clearSearch()">{{$t('button.resetFilter')}}
                            </b-button>
                        </div>
                    </div>

                    <div class="card-body">
                        <form role="form">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>{{$t('form.student.searchCriteria')}}</label>
                                        <v-select @input="loadPreset" label="name" :options="presetList"
                                            v-model="preset"></v-select>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>{{$t('form.student.partnerCode')}}</label>
                                        <v-select label="PartnerCode" :options="partners" v-model="search.partnerId"
                                            @input="filterList" :reduce="partners => partners.PartnerID"></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>{{$t('form.import.type')}}</label>
                                        <select class="form-control" v-model="search.type" @change="filterList">
                                            <option value="">{{$t('form.student.select')}}</option>
                                            <option value="student">{{$t('form.import.student')}}</option>
                                            <option value="grade">{{$t('form.import.grade')}}</option>
                                            <option value="graduation">{{$t('form.import.graduation')}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>{{$t('form.import.date')}}</label>
                                        <date-picker :lang="lang" class="date-picker" v-model="search.date" valueType="format"
                                            :format="dateFormat" @change="filterList"
                                            :popup-style="{ top: '100%', left: 0}" :append-to-body="false">
                                        </date-picker>
                                    </div>
                                </div>
                            </div>

                            <div class="row" v-if="detailedSearch">
                                <div class="col-12">
                                    <hr />
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <input type="text" v-model="preset.name" class="form-control"
                                            :placeholder="$t('form.student.presetName')" />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <button class="btn btn-primary" type="button"
                                        @click="savePreset">{{$t('button.save')}}</button>
                                    <button class="btn btn-danger" type="button" v-show="presetSelected"
                                        @click="deletePreset">{{$t('button.delete')}}</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <!-- Student's List -->
                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.import.record')}}</div>
                    </div>

                    <div class="card-body table-responsive p-0">
                        <table class="table table-hover" v-if="list.length">
                            <thead>
                                <tr>
                                    <th>{{$t('form.import.id')}}</th>
                                    <th>{{$t('form.import.partner')}}</th>
                                    <!-- <th>{{$t('form.import.user')}}</th> -->
                                    <th>{{$t('form.import.type')}}</th>
                                    <th>{{$t('form.import.data')}}</th>
                                    <th>{{$t('form.import.signature')}}</th>
                                    <th>{{$t('form.import.date')}}</th>
                                </tr>
                            </thead>

                            <tbody v-for="item in list" :key="item.id">
                                <tr>
                                    <td>{{item.id}}</td>
                                    <td>{{item.partner_id ? item.partner.PartnerCode : ''}}</td>
                                    <!-- <td>{{item.user_id ? item.user.name : ''}}</td> -->
                                    <td>{{item.type}}</td>
                                    <td>{{item.data}}</td>
                                    <td>
                                        <a href="#" target="_blank" @click.prevent="download(item)"
                                            v-if="item.signature">{{$t('button.view')}}</a>
                                    </td>
                                    <td>{{item.date | formatDate(datetimeFormat)}}</td>
                                </tr>
                            </tbody>
                        </table>
                        <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>
                    </div>

                    <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5"
                        @paginate="paginate()"></pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['permissions', 'dateFormat', 'datetimeFormat'],

        data() {
            return {

                fullPage: true,
                isLoading: false,

                detailedSearch: false,

                alert: false,
                alertClass: '',
                alertMessage: '',

                presetSelected: false,
                request_source: '',

                lang: {
                    formatLocale: {
                        firstDayOfWeek: 1,
                    },
                },

                preset: {
                    name: '',
                    entity: 'import-record',
                    value: {}
                },

                search: {
                    type: '',
                },

                pagination: {
                    current_page: 1
                },

                list: [],
                partners: [],
                presetList: [],
            }
        },

        async mounted() {
            this.isLoading = true;

            if (!this.permissions.viewImportRecords) {
                this.$router.push('/');
                return;
            }

            await this.getPartners();

            if (localStorage.getItem('filter-import')) {
                this.search = JSON.parse(localStorage.getItem('filter-import'));
            }

            this.getImportRecords();
            this.getPresets();
        },

        watch: {
            search: {
                handler(newSearch) {
                    localStorage.setItem('filter-import', JSON.stringify(this.search));

                    const emojiRegex = /[\u{10000}-\u{10FFFF}]/gu;
                    
                    // Loop through all properties in the search object
                    Object.keys(newSearch).forEach(key => {
                    // Only process string values
                    if (typeof newSearch[key] === 'string' && emojiRegex.test(newSearch[key])) {
                        // Strip the emoji and update the reactive property
                        this.search[key] = newSearch[key].replace(emojiRegex, '');
                    }
                    });
                },
                deep: true  
            }
        },

        methods: {

            async createToken(type) {
                let response = await axios.post('/api/api-tokens', {
                    type
                });
                let token = '';

                if (response.status == 200) {
                    token = response.data.extra[0].token
                }

                return token;
            },

            async download(record) {
                let token = await this.createToken('student-attachment');
                if (token == '') return;

                window.open(`/users/signature/${record.id}?token=${token}`, '_blank');
            },

            /**
             * Build Query String for Filters
             */
            buildQueryString(obj) {
                let query = '';

                Object.keys(obj).forEach(function (key) {
                    if (key == "numberRange" && obj[key].from && obj[key].to) {
                        query += key + "=" + encodeURIComponent(obj[key].from) + "," + encodeURIComponent(obj[key].to) + "&";
                    }
                    else if (obj[key] != "" && key != "numberRange" && obj[key] != null) {
                        query += key + "=" + encodeURIComponent(obj[key]) + "&";
                    }
                });

                return query.slice(0, -1);
            },

            /**
             * Reset applied filters
             */
            clearSearch() {
                this.search = {
                    type: '',
                };

                this.filterList();
            },

            /**
             * Toggle detail search
             */
            toggleDetailedSearch() {
                this.detailedSearch = !this.detailedSearch;
            },

            /**
             * Get Import Record list
             */
            getImportRecords() {
                let source = axios.CancelToken.source();

                if (this.request_source != '') {
                    this.request_source.cancel('Operation canceled by the user.');
                    console.clear();
                }

                this.request_source = source;

                let filters = this.buildQueryString(this.search);
                if (filters != '') filters = '&' + filters;

                this.isLoading = true;

                axios
                    .get("/api/import-records?page=" + this.pagination.current_page + filters, {
                        cancelToken: this.request_source.token
                    })
                    .then(response => {
                        this.list = response.data.data.data;
                        this.pagination = response.data.pagination;

                        this.isLoading = false;
                    })
                    .catch(error => console.log('error'));
            },

            /**
             * Apply paginate
             */
            paginate() {
                this.getImportRecords();
            },

            /**
             * Apply filters
             */
            filterList() {
                if (this.pagination.total > 0) {
                    this.downloadToggle = true;
                }

                this.pagination.current_page = 1;

                this.getImportRecords();
            },

            /**
             * Get Partners List
             */
            async getPartners() {
                await axios
                    .get("/api/partners?full")
                    .then(resp => this.partners = resp.data)
                    .catch(error => console.log('error fetching partners'));
            },

            /**
             * Show alert
             */
            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            },

            /**
             * Save Preset into database
             */
            savePreset() {
                this.isLoading = true;
                this.alert = false;

                this.preset.value = JSON.stringify(this.search);

                axios
                    .post('/api/presets', this.preset)
                    .then(response => {
                        this.isLoading = false;
                        this.showAlert(response.data.message);
                        this.getPresets();
                    }, error => {
                        this.isLoading = false;

                        if (error.response.status == 422)
                            this.showAlert(error.response.data.errors.name[0], 'danger');
                    })
                    .catch(errors => console.log(errors.response));
            },

            /**
             * Get Preset List
             */
            getPresets() {
                axios
                    .get('/api/presets/?entity=' + this.preset.entity)
                    .then(response => {
                        this.presetList = response.data;
                    }, error => {
                        console.log(error.response);
                    });
            },

            /**
             * Load Preset and apply Filters
             */
            loadPreset() {
                if (!this.preset) {
                    this.preset = {
                        name: '',
                        entity: 'import-record',
                        value: {}
                    };

                    this.clearSearch();
                    this.alert = false;
                    this.presetSelected = false;
                    return;
                }

                this.alert = false;
                this.presetSelected = true;
                this.search = JSON.parse(this.preset.value);
                this.filterList();
            },

            /**
             * Delete the specific preset
             */
            deletePreset() {

                if (!confirm(this.$t('form.validation.delete'))) {
                    return;
                }

                axios
                    .delete("/api/presets/" + this.preset.id)
                    .then(response => {
                        if (response.data.status == 'success') {
                            this.showAlert(response.data.message);
                            this.getPresets();
                            this.clearSearch();
                            this.preset.name = '';
                            this.preset.value = {};
                            this.presetSelected = false;
                        }
                    })
                    .catch(error => {
                        this.isLoading = false;
                    });
            },
        }
    };

</script>
